module.exports = __webpack_public_path__ + "static/media/courseFallback.922fc8c9.png";